import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { api, errorCode, errorText } from "../lib/api";
import { FLOWER_COLORS, FLOWER_KINDS } from "../lib/constants";

export const FlowerIcon = ({ kind, size = 34 }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" aria-hidden="true">
    <path d="M20 22 C20 30 19 34 18 38" stroke="#5d6b4f" strokeWidth="1.6" fill="none" />
    <path d="M19.5 30 C15 28 13 29 12 31 C15 32 17 31.5 19.5 30Z" fill="#6f7f5c" />
    {[0, 72, 144, 216, 288].map((a) => (
      <ellipse key={a} cx="20" cy="12" rx="4.2" ry="7" fill={FLOWER_COLORS[kind]} stroke="rgba(0,0,0,0.08)" transform={`rotate(${a} 20 18)`} />
    ))}
    <circle cx="20" cy="18" r="3.4" fill={kind === "sunflower" ? "#6b4a2b" : "#e9c46a"} />
  </svg>
);

export const FlowerDialog = ({ open, onOpenChange, slug, onLeft }) => {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const leave = async (kind) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/memorials/${slug}/flowers`, { kind });
      toast.success(t("memorial.flower_thanks"));
      onLeft?.(data.flowers_count, kind);
      onOpenChange(false);
    } catch (e) {
      if (errorCode(e) === "flower_already_left") toast(t("memorial.flower_already"));
      else toast.error(errorText(t, e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md rounded-3xl" data-testid="flower-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl font-normal">{t("memorial.leave_flower")}</DialogTitle>
          <DialogDescription>{t("memorial.flower_choose")}</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3 pt-2">
          {FLOWER_KINDS.map((k) => (
            <button key={k} disabled={busy} onClick={() => leave(k)} data-testid={`flower-option-${k}`} className="stone-chip flex flex-col items-center gap-2 rounded-2xl border p-4 hover:border-[hsl(var(--accent))] hover:shadow-lg disabled:opacity-50">
              <FlowerIcon kind={k} size={44} />
              <span className="text-sm font-semibold">{t(`flowers.${k}`)}</span>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
